export default function Confirm()
{
    return (
        <div>
    <h1>Успешна регистрация</h1>
            
        </div>
    );
}
